import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import zerodhaLogo from "../images/investors-images/zerodha.png"

const Zerodha = () => (
  <img src={zerodhaLogo}/>
  // <StaticQuery
  //   query={graphql`
  //     query {
  //       placeholderImage: file(relativePath: { eq: "investors-images/zerodha.png" }) {
  //         childImageSharp {
  //           fluid(maxWidth: 3000) {
  //             ...GatsbyImageSharpFluid_noBase64
  //           }
  //         }
  //       }
  //     }
  //   `}
  //   render={data => <Img fluid={data.placeholderImage.childImageSharp.fluid} style={{width: '32%'}}/>}
  // />
)
export default Zerodha
